import { Component, OnInit, Input, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-diploma-level3',
  templateUrl: './diploma-level3.component.html',
  styleUrls: ['./diploma-level3.component.scss']
})
export class DiplomaLevel3Component implements OnInit {

  @Input('job') singleJob;
  @Input('learner') singleLearner;
  @Input('assessment') assessmentEdit;
  jobData
  learnerData
  marketingSchemaFormEdit
  layout = true
  level3 = true
  jobId
  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log("changes of job and learner data", changes);
    if (changes.singleJob && changes.singleJob.currentValue) {
      this.jobData = changes.singleJob.currentValue
      this.jobId = this.jobData[0]._id
      // this.instructorsList = this.jobData.instructors
      console.log("instructorsList ====== instructorsList", this.jobData);

    }

    if (changes.singleLearner && changes.singleLearner.currentValue) {
      this.learnerData = changes.singleLearner.currentValue
    }

    if (changes.assessmentEdit && changes.assessmentEdit.currentValue) {
      this.marketingSchemaFormEdit = changes.assessmentEdit.currentValue
    }

  }

}
